import { getDecodedWeaveToken, isWeaveUser } from '@frontend/auth-helpers';
import { theme } from '@frontend/theme';
import { PrivilegedLocationPicker, UnprivilegedMultiLocationSelector } from './location-pickers';

const UnprivilegedLocationPicker = ({ closeModal, simple = false }: { closeModal?: () => void; simple?: boolean }) => {
  const params = new URLSearchParams();
  const decodedWeaveToken = getDecodedWeaveToken();

  for (const id in decodedWeaveToken?.ACLS) {
    params.append('location_id', id);
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: 1,
        paddingTop: theme.spacing(1),
      }}
    >
      <UnprivilegedMultiLocationSelector closeModal={closeModal} simple={simple} />
    </div>
  );
};

export const LocationPicker = ({ closeModal, simple = false }: { closeModal?: () => void; simple?: boolean }) => {
  return (
    <>
      {isWeaveUser() ? (
        <PrivilegedLocationPicker isSimpleView={simple} closeModal={closeModal} />
      ) : (
        <UnprivilegedLocationPicker simple={simple} closeModal={closeModal} />
      )}
    </>
  );
};

export const DecoratedLocationPicker = ({
  closeModal,
  simple = false,
}: {
  closeModal?: () => void;
  simple?: boolean;
}) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        maxHeight: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <LocationPicker closeModal={closeModal} simple={simple} />
    </div>
  );
};
